export class HttpConfig {
    apiName: string;
    apiUrl: string;
    apiStage: string;
    apiKey: string;
    region: string;   
}

export class Path {
    
    private args: any[] = [];
    private params: any = {};

    constructor(
        public name: string,
        public apiName: string,
        public needAuth: boolean = true
    ) {}

    setArgs(args: any[]): Path {
        this.args = args;
        return this;
    }

    setQueryParams(params:any): Path{
        this.params = params;
        return this;
    }

    getPath(): string {
        let path = this.name;
        this.args.forEach(arg => {
            path += arg + '/';
        });
        this.args = [];

        if(!!Object.keys(this.params)?.length){
            let query='';
            Object.keys(this.params).map(key => {
                if(query!='') query+='&';
                query += key + '=' + encodeURI(this.params[key]);
            });
            path +='?'+query;
            this.params = [];
        }
        return path;
    }

}